import React,{useState,useEffect,useRef} from 'react'
import Functions from './function'
import { useParams } from 'react-router-dom';
import { QRCodeCanvas } from "qrcode.react";

const Index = () => {
    const [orderdata,setOrderData] = useState(null);
    const {id} = useParams();
    // useRef, not a plain let: a local would reset on every render and never guard anything,
    // so window.print() could fire more than once.
    const inprint = useRef(false);
    useEffect(()=>{
        Functions.Get(id,(data)=>{
            setOrderData(data);
            if(!inprint.current){
                setTimeout(() => {
                    window.print();
                    window.close();
                }, 400);
            }
            inprint.current = true;
        });
    },[id])
  return (
    <>
    {orderdata &&
        <div style={{margin:"15px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <p style={{fontSize:"10px"}}>Invoice No: <b style={{fontWeight:"600",fontSize:"10px"}}>{id}</b></p>
                <p style={{fontSize:"10px"}}>Pan No: <b style={{fontWeight:"600",fontSize:"10px"}}>{orderdata.workingpan}</b></p>
            </div>
            <div style={{border:"2px solid #646464",padding:"5px"}}>
                <h5 style={{fontSize:"15px"}}>To</h5>
                <div style={{padding:"2px 10px"}}>
                    <p style={{fontSize:"10px"}}>Practice: <b style={{fontSize:"10px"}}>{orderdata.clinicname+ " / Dr." + orderdata.doctorname}</b></p>
                    <p style={{fontSize:"12px"}}>Patient: <b style={{fontSize:"12px"}}>{orderdata.patient}</b></p>
                    <p style={{fontSize:"10px"}}>Address: <b style={{fontSize:"10px"}}>{orderdata.clinicaddress}</b></p>
                    <p style={{fontSize:"10px"}}>Email: <b style={{fontSize:"10px"}}>{orderdata.doctoremail}</b></p>
                    <p style={{fontSize:"10px"}}>Phone: <b style={{fontSize:"10px"}}>{orderdata.doctorcontact}</b></p>
                </div>
            </div>
            <div style={{borderBottom:"2px solid #646464",borderLeft:"2px solid #646464",borderRight:"2px solid #646464",padding:"5px", margin:"0px 0px"}}>
                <h5 style={{fontSize:"15px"}}>From</h5>
                <div style={{padding:"2px 10px"}}>
                    <div style={{display:"flex"}}>
                        <div style={{width:"80%"}}>
                            <p style={{fontSize:"10px"}}>P 369, Street#2, Block B, Alnajaf Colony, Faisalabad, Pakistan. 38000</p>
                            <p style={{fontSize:"10px"}}>Email: fsd@nvisiodental.com</p>
                            <p style={{fontSize:"10px"}}>www.nvisiodental.com</p>
                            <p style={{fontSize:"10px"}}>+92 (300) 460 - 1314</p>
                        </div>
                        <div style={{width:"20%"}}>
                        <QRCodeCanvas
                            id="qrCode"
                            value={id}
                            bgColor={"#ffffff"}
                            level={"H"}
                            size={60}
                        />
                        </div>
                    </div>
                    
                </div>
            </div>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", margin:"5px 0px"}}>
                <div style={{borderBottom:"1px solid black"}}>
                    <h3 style={{fontWeight:"500",fontSize:"8px"}}>Checked by</h3>
                    <div style={{width:"40vw"}}></div>
                </div>
                <div style={{borderBottom:"1px solid black"}}>
                    <h3 style={{fontWeight:"500",fontSize:"8px"}}>Delivered by</h3>
                    <div style={{width:"40vw"}}></div>
                </div>
            </div>
        </div>
    }
    </>
  )
}

export default Index
